import { render } from "./Header.vue?vue&type=template&id=4055e64a"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "/Users/perro/Documents/Repositorios/github/guaw/clicsocial/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.8_vue@3.5.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__